<template>
  <div>
    <serviceRecordStep1 v-if="step == 1" @queryRecord="queryRecord" />
    <serviceRecordStep2
      v-if="step == 2"
      @queryRecordDetail="queryRecordDetail"
      @restartQuery="previousStep"
      :name="userName"
    />
    <serviceRecordStep3
      v-if="step == 3"
      @previousStep="previousStep"
      :recordInfo="recordInfo"
    />
  </div>
</template>

<script>
import store from 'Store/store';
import serviceRecordStep1 from 'Pages/ServiceModule/ServiceRecord/ServiceRecordStep1.vue';
import serviceRecordStep2 from 'Pages/ServiceModule/ServiceRecord/ServiceRecordStep2.vue';
import serviceRecordStep3 from 'Pages/ServiceModule/ServiceRecord/ServiceRecordStep3.vue';

export default {
  name: 'Service3',
  components: {
    serviceRecordStep1,
    serviceRecordStep2,
    serviceRecordStep3,
  },
  data() {
    return {
      page: this.$route.query.page,
      step: this.$route.query.step || '1',
      recordId: '',
      applyInfo: {
        applyName: '',
        applyPhone: '',
      },
      recordInfo: {},
    };
  },
  computed: {
    userName() {
      return this.applyInfo.name;
    },
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
      this.step = this.$route.query.step || '1';
    },
    step: function(val) {
      if (val == '2') {
        if (this.applyInfo.name === undefined) {
          this.$router.push({
            path: '/service',
            query: { page: '4', step: '1' },
          });
          return;
        }
        let infoRequest = {
          applyName: this.applyInfo.name,
          applyPhone: this.applyInfo.phone,
        };
        let strInfoRequest = JSON.stringify(infoRequest);
        let getBookingListRequest = { param: strInfoRequest };
        store.dispatch('main/clearBookingList');
        store.dispatch('main/getBookingList', getBookingListRequest);
      }

      if (val == '3') {
        let recordInfo = {
          orderId: this.recordId,
          applyName: this.applyInfo.name,
          applyPhone: this.applyInfo.phone,
        };
        let strInfoRequest = JSON.stringify(recordInfo);
        let getBookingInfoRequest = { param: strInfoRequest };
        store.dispatch('main/clearBookingInfo').then(() => {
          store
            .dispatch('main/getBookingInfo', getBookingInfoRequest)
            .then(() => {
              if (
                store.state.main.bookingInfo !== undefined &&
                store.state.main.bookingInfo !== {}
              ) {
                const record = store.state.main.bookingList.find(
                  (element) => element.orderId === this.recordId
                );
                this.recordInfo = { ...recordInfo, ...record };
              }
            });
        });
      }
    },
  },
  mounted() {
    if (this.step != '1') {
      this.$router.push({ path: '/service', query: { page: '4', step: '1' } });
    }
  },
  methods: {
    queryRecord(applyInfo) {
      this.applyInfo = applyInfo;
      this.$router.push({ path: '/service', query: { page: '4', step: '2' } });
    },
    queryRecordDetail(recordId) {
      this.recordId = recordId;
      this.$router.push({ path: '/service', query: { page: '4', step: '3' } });
    },
    previousStep() {
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
